import styled from 'styled-components'
import { Card } from 'antd'


export const StyledCard = styled(Card)`
  min-height: 82vh;
  
  .text {
    margin: 10px 0;
    font-size: 14px;
    padding: 0px 25%;
    text-align: left;
  }
  img {
    margin-bottom: 50px;
  }
  .ant-card {
      background: #0076bf;
      color: #fff;
      font-size: 17px;
      text-align: center;
      cursor: pointer;
      a {
        color: #fff;
      }
      &:hover {
        background: #71bf47;
      }
  }
`



// WEBPACK FOOTER //
// ./src/components/PortFolioManager/style.js